import { injectable, inject } from '@patsnap/tahiti-core/shared/inversify';
import { Emitter } from '@patsnap/tahiti-core/common/event';
import { PermissionModel } from '../../models/permission-model';
import type { Permission } from '../../types';
import type { PermissionService } from '../permission-service';

@injectable()
export class PermissionServiceImpl implements PermissionService {
    private _onStatesChangeEmitter = new Emitter<Permission>();
    readonly onStatesChange = this._onStatesChangeEmitter.event;

    constructor(
        @inject(PermissionModel)
        private _model: PermissionModel,
    ) {
        this._model.onStatesChange(this._emitModelDataChange.bind(this));
    }

    private _emitModelDataChange() {
        this._onStatesChangeEmitter.fire(this.getModelData());
    }

    public getModelData() {
        return this._model.modelData;
    }

    public updatePermission(permissions: Permission) {
        this._model.update(() => ({
            ...permissions,
            patentValue: permissions.patentValue && permissions.displayPatentValueFlag !== true,
        }));
    }
}
